import { render, staticRenderFns } from "./FooterComponentJnjtsat.vue?vue&type=template&id=512eb9c6&scoped=true"
import script from "./FooterComponentJnjtsat.vue?vue&type=script&lang=ts"
export * from "./FooterComponentJnjtsat.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentJnjtsat.vue?vue&type=style&index=0&id=512eb9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512eb9c6",
  null
  
)

export default component.exports